<template>
  <vx-card>
    <div id="page-user-list">
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>
            Add New Accounts/Contacts To {{ campaignDescription.campaign_name }} With Advanced Criteria
            
          </h3>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        > <vs-button @click="finish">Finish</vs-button>
        </vs-col>
      </vs-row>

      <div>
        <!-- AgGrid Table -->
        <DataGrid :context="'AddNewAccountsWithAdvancedCriteria'" 
        @sendSelectionToActualPage="sendSelectionToActualPage"
        :key="companySearchComponentKey"
          @showCampaignStatusPopup="showCampaignStatusPopup"
          ref="AddNewAccountsWithAdvancedCriteria"
          :columnDefs="columnDefs"
          :rowData="accounts"
          :dataSource="dataSource"
        >
        </DataGrid>
      </div>
     <vs-popup
          style="z-index: 999999;"
          class="holamundo"
          title="Campaign Details"
          :active.sync="showCampaignDetailsPopUp"
        >
          <div class="text-center" v-if="selected_contact_details">
            <h5>
              Contact : {{ selected_contact_details.forename }}
              {{ selected_contact_details.surname }}
            </h5>
          </div>
          <template v-if="campaign_statuses.includes('Live')">
            <h6>Active Campaigns</h6>
            <vs-table
              class="mb-10"
              stripe
              v-if="selected_contact_details_campaigns"
              :data="selected_contact_details_campaigns"
            >
              <template slot="thead">
                <vs-th sort-key="campaign_code">Campaign Code</vs-th>
                <vs-th sort-key="campaign_name">Campaign Name</vs-th>
                <vs-th sort-key="campaign_status">Campaign Status</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <template v-if="data[indextr].campaign_status == 'Live'">
                    <vs-td :data="data[indextr].campaign_code">
                      {{ data[indextr].campaign_code }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_name">
                      {{ data[indextr].campaign_name }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_status">
                      {{ data[indextr].campaign_status }}
                    </vs-td>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </template>

          <template v-if="campaign_statuses.includes('Paused')">
            <h6>Paused Campaigns</h6>
            <vs-table
              class="mb-10"
              stripe
              v-if="selected_contact_details_campaigns"
              :data="selected_contact_details_campaigns"
            >
              <template slot="thead">
                <vs-th sort-key="campaign_code">Campaign Code</vs-th>
                <vs-th sort-key="campaign_name">Campaign Name</vs-th>
                <vs-th sort-key="campaign_status">Campaign Status</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <template v-if="data[indextr].campaign_status == 'Paused'">
                    <vs-td :data="data[indextr].campaign_code">
                      {{ data[indextr].campaign_code }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_name">
                      {{ data[indextr].campaign_name }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_status">
                      {{ data[indextr].campaign_status }}
                    </vs-td>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </template>

          <template v-if="campaign_statuses.includes('Completed')">
            <h6>Historic Campaigns</h6>
            <vs-table
              class="mb-10"
              stripe
              v-if="selected_contact_details_campaigns"
              :data="selected_contact_details_campaigns"
            >
              <template slot="thead">
                <vs-th sort-key="campaign_code">Campaign Code</vs-th>
                <vs-th sort-key="campaign_name">Campaign Name</vs-th>
                <vs-th sort-key="campaign_status">Campaign Status</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <template v-if="data[indextr].campaign_status == 'Completed'">
                    <vs-td :data="data[indextr].campaign_code">
                      {{ data[indextr].campaign_code }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_name">
                      {{ data[indextr].campaign_name }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_status">
                      {{ data[indextr].campaign_status }}
                    </vs-td>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </template>

          <div></div>
        </vs-popup>
    </div>
  </vx-card>
</template>

<script>
var revanueValueFormatter = function(params) {
  if(params.data.revenue){

    if(params.data.currency_name != undefined){
      return params.data.currency_name + " " + params.data.revenue;
    }
  }
};

var seniorityValueFormatter = function(params) {
  return params.value
};

var roleValueFormatter = function(params) {
  console.log(params)
};

var campaignStatus = function campaignStatus(params) {
  let active_status = "";
  let historic_status = "";
  let member_status = "";
  let paused_status = "";

  let contacts_clients = params.data.campaign_client_id;
  let campaign_clients = window.campaignDescriptionWithClients.campaign_clients;

  const found = campaign_clients.some(r => contacts_clients.indexOf(r) >= 0);
  if (found) {
    const arrayOfStrings = params.data.campaign_status;

    if (window.live_campaign_status == true) {
      const active_str = "Live";
      const active_found = arrayOfStrings.find(v => active_str === v);
      if (active_found) {
        active_status =
          '<span><i class="material-icons">text_format</i></span>';
      }
    }

    if (window.completed_campaign_status == true) {
      const historic_str = "Completed";
      const historic_found = arrayOfStrings.find(v => historic_str === v);
      if (historic_found) {
        historic_status =
          '<span><i class="material-icons">check_circle_outline</i></span>';
      }
    }

    if (window.paused_campaign_status == true) {
      const paused_str = "Paused";
      const paused_found = arrayOfStrings.find(v => paused_str === v);
      if (paused_found) {
        paused_status =
          '<span><i class="material-icons">pause_circle_outline</i></span>';
      }
    }

    if (window.member_campaign_status == true) {
      const arrayOfIds = params.data.campaign_ids;
      const campaignId = window.location.pathname.split("/").pop();
      const member_found = arrayOfIds.find(v => campaignId === v);
      if (member_found) {
        member_status =
          '<span><i class="material-icons">perm_identity</i></span>';
      }
    }

    return (
      active_status +
      " " +
      historic_status +
      " " +
      member_status +
      " " +
      paused_status
    );
  }
};

var DatefilterParams = {
  comparator: function(filterLocalDateAtMidnight, cellValue) {
    // In the example application, dates are stored as dd/mm/yyyy
    // We create a Date object for comparison against the filter date
    var dateParts = cellValue.split("/");
    var day = Number(dateParts[2]);
    var month = Number(dateParts[1]) - 1;
    var year = Number(dateParts[0]);
    var cellDate = new Date(day, month, year);

    // Now that both parameters are Date objects, we can compare
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  },
  browserDatePicker: true,
  minValidYear: 2000
};
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import { CampaignStatusFilter } from "@/components/aggrid/CampaignStatusFilter.js";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
export default {
  components: {
    DataGrid,
    CampaignStatusFilter: CampaignStatusFilter
  },
  name: "EnrichExtraAccountsContacts",
  data() {
    return {
      selected_contact_ids: [],
      companySearchComponentKey: 0,
      enrich_master_account_website_field_columns: '',
      enrich_master_account_linkedin_field_columns: '',
      enrich_master_account_sic_code_field_columns: '',
      enrich_master_account_phone_field_columns: '',
      enrich_master_account_switchboard_field_columns : '',
      enrich_master_contact_job_title_field_columns : '',
      enrich_master_contact_email_field_columns : '',
      enrich_master_contact_ddi_field_columns : '',
      enrich_master_contact_mobile_field_columns : '',
      enrich_master_contact_role_field_columns : '',
      enrich_master_contact_sub_role_field_columns : '',
      enrich_master_contact_seniority_field_columns : '',
      enrich_master_contact_social_media_field_columns : '',
      enrich_master_contact_core_field_columns : '',
      enrich_master_account_core_field_columns: '',
      enrich_master_account_none_core_field_columns: '',
    enrich_master_account_none_core_field_ids: '',
    enrich_master_contact_none_core_field_columns: '',
    enrich_master_contact_none_core_field_ids: '',
    enrich_none_core_number_type_ids : [],
      campaign_statuses: [],
            selected_contact_details: null,
      showCampaignDetailsPopUp: false,
      selected_contact_details_campaigns: null,
      dataSource: {},
      campaignDescription: [],
      accounts: [],
      columnDefs: [
      ]
    };
  },
  watch: {
    showCampaignDetailsPopUp: function(value) {
      if (value) {
        if (window.live_campaign_status == false) {
          this.campaign_statuses = this.campaign_statuses.filter(function(
            item
          ) {
            return item !== "Live";
          });
        }

        if (window.completed_campaign_status == false) {
          this.campaign_statuses = this.campaign_statuses.filter(function(
            item
          ) {
            return item !== "Completed";
          });
        }

        if (window.paused_campaign_status == false) {
          this.campaign_statuses = this.campaign_statuses.filter(function(
            item
          ) {
            return item !== "Paused";
          });
        }
      }
    }
  },
  computed: {},
  methods: {
    sendSelectionToActualPage(items) {



let self = this;
self.selected_contact_ids = [];

items.forEach(element => {

  self.selected_contact_ids.push(element.contact_id);
});

self.selected_contact_ids = [... new Set(self.selected_contact_ids)]



},

    getSelectedCampaignFieldForEnrich() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAlreadySelectedCampaignField",
          this.$route.params.campaignId
        )
        .then(response => {
          let result = response.data
          let selected_account_columns = JSON.parse(result['account_fields']);



             selected_account_columns = selected_account_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' && ele.identifier != 'currency_code' 
              });


              var index = 1;
            selected_account_columns.forEach(function(ele) {

              ele.id = ele.uuid

          
              ele.headerName = ele.name;

              if (ele.identifier == 'none_core_field') {
                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }
                let ele_with_t = 'acc' + index + '.' + ele.field;

                if (ele.type == 'number'){
                  self.enrich_none_core_number_type_ids.push(ele.field)
                }



                self.enrich_master_account_none_core_field_columns = self.enrich_master_account_none_core_field_columns + ',' + ele.id;

                self.enrich_master_account_none_core_field_ids = self.enrich_master_account_none_core_field_ids + ',' + ele_with_t;


                  // if (ele.type == 'number'){
                  //   self.enrich_master_account_none_core_field_ids = self.enrich_master_account_none_core_field_ids + '::bigint,' + ele_with_t;
                  // }else{
                  //   self.enrich_master_account_none_core_field_ids = self.enrich_master_account_none_core_field_ids + ',' + ele_with_t;
                  // }

                
                index += 1;

                }else{
                  ele.field = ele.identifier;
                  let account_identifier = null

                  if (ele.identifier == 'linkedin'){
                    account_identifier = " string_agg(distinct l.url, ',') as linkedin ";
                    self.enrich_master_account_linkedin_field_columns = self.enrich_master_account_linkedin_field_columns + ',' + account_identifier
                  }
                  else if (ele.identifier == 'sic_code'){
                    // account_identifier = " (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct scl.code  , ' , ')) , ' , ')) , ' , ') from account_sic_codes a_s_c left join sic_code_lists scl on scl.uuid == a_s_c.sic_code_id where a_s_c.account_id = a.uuid limit 1 ) as sic_code ";
                    // self.enrich_master_account_sic_code_field_columns = self.enrich_master_account_sic_code_field_columns + ',' + account_identifier
                  }
                  else if (ele.identifier == 'website'){
                    account_identifier = " string_agg(distinct w.url, ',') as website ";
                    self.enrich_master_account_website_field_columns = self.enrich_master_account_website_field_columns + ',' + account_identifier
                  }
                  else if (ele.identifier == 'phone'){
                    account_identifier = " (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct p.phone_no  , ' , ')) , ' , ')) , ' , ') from phone ph  limit 1 ) as phone ";
                    self.enrich_master_account_phone_field_columns = self.enrich_master_account_phone_field_columns + ',' + account_identifier
                  }
                  else if (ele.identifier == 'switchboard'){
                    account_identifier = " (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct p.phone_no  , ' , ')) , ' , ')) , ' , ') from phone ph  limit 1 ) as switchboard ";
                    self.enrich_master_account_switchboard_field_columns = self.enrich_master_account_switchboard_field_columns + ',' + account_identifier
                  }
                  else {
                  
                  account_identifier = 'a.' + ele.identifier;
                  self.enrich_master_account_core_field_columns = self.enrich_master_account_core_field_columns + ',' + account_identifier
                }
                 
                }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.columnDefs = selected_account_columns

          localStorage.setItem("enrich_master_account_none_core_field_columns", self.enrich_master_account_none_core_field_columns);
          localStorage.setItem("enrich_master_account_none_core_field_ids", self.enrich_master_account_none_core_field_ids);

          localStorage.setItem("enrich_none_core_number_type_ids", self.enrich_none_core_number_type_ids);

          

          localStorage.setItem("enrich_master_account_core_field_columns", self.enrich_master_account_core_field_columns);

          localStorage.setItem("enrich_master_account_website_field_columns", self.enrich_master_account_website_field_columns);
          localStorage.setItem("enrich_master_account_linkedin_field_columns", self.enrich_master_account_linkedin_field_columns);

          localStorage.setItem("enrich_master_account_phone_field_columns", self.enrich_master_account_phone_field_columns);

          localStorage.setItem("enrich_master_account_switchboard_field_columns", self.enrich_master_account_switchboard_field_columns);

          


            self.columnDefs.push({  headerCheckboxSelection: true,
              headerCheckboxSelectionFilteredOnly: true,
            headerName: "Actions",
            field: "transactions",
            cellRenderer: "CellRendererActions",
            suppressHeaderMenuButton: true,
            checkboxSelection: true,

            pinned: true,
            width: 50 }
            );







          let selected_contact_columns = JSON.parse(result['contact_fields']);


          selected_contact_columns = selected_contact_columns.filter(function(ele) {
              return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' 
            });

            var index = 1;
            selected_contact_columns.forEach(function(ele) {

              ele.id = ele.uuid

              ele.headerName = ele.name;

              

              if (ele.identifier == 'none_core_field') {



                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }
                let ele_with_t = 'con' + index + '.' + ele.field;

                if (ele.type == 'number'){
                  self.enrich_none_core_number_type_ids.push(ele.field)
                }

                self.enrich_master_contact_none_core_field_columns = self.enrich_master_contact_none_core_field_columns + ',' + ele.id;
                self.enrich_master_contact_none_core_field_ids = self.enrich_master_contact_none_core_field_ids + ',' + ele_with_t;
                index += 1;

                }else{
                  let contact_identifier = null
                  ele.field = ele.identifier;
                  if (ele.identifier == 'title' || ele.identifier == 'surname' || ele.identifier == 'forename' ){
                    contact_identifier = 'c.' + ele.identifier;
                    self.enrich_master_contact_core_field_columns = self.enrich_master_contact_core_field_columns + ',' + contact_identifier
                  }
                  else if (ele.identifier == 'job_title'){
                    contact_identifier = 'cjt.' + ele.identifier;
                    self.enrich_master_contact_job_title_field_columns = self.enrich_master_contact_job_title_field_columns + ',' + contact_identifier
                  }
                  else if (ele.identifier == 'email'){
                    contact_identifier = "(Select ce.email from contact_email ce where ce.accounts_contacts_id = ac.uuid limit 1)";
                    self.enrich_master_contact_email_field_columns = self.enrich_master_contact_email_field_columns + ',' + contact_identifier
                  }
                  else if (ele.identifier == 'contact_social_media'){
                    contact_identifier = " (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct csm.social_media  , ' , ')) , ' , ')) , ' , ') from contact_social_media csm where csm.accounts_contacts_id = ac.uuid limit 1 ) as contact_social_media ";
                    self.enrich_master_contact_social_media_field_columns = self.enrich_master_contact_social_media_field_columns + ',' + contact_identifier
                  }
                  else if (ele.identifier == 'mobile'){
                    contact_identifier = " (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct cm.mobile  , ' , ')) , ' , ')) , ' , ') from contact_mobile cm where cm.accounts_contacts_id = ac.uuid limit 1 ) as mobile ";
                    self.enrich_master_contact_mobile_field_columns = self.enrich_master_contact_mobile_field_columns + ',' + contact_identifier
                  }
                  else if (ele.identifier == 'ddi'){
                    contact_identifier = " (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct cd.ddi  , ' , ')) , ' , ')) , ' , ') from contact_ddi cd where cd.accounts_contacts_id = ac.uuid limit 1 ) as ddi ";
                    self.enrich_master_contact_ddi_field_columns = self.enrich_master_contact_ddi_field_columns + ',' + contact_identifier
                  }
                  else if (ele.identifier == 'role'){
                    contact_identifier = 'cr.' + ele.identifier;
                    self.enrich_master_contact_role_field_columns = self.enrich_master_contact_role_field_columns + ',' + contact_identifier
                  }
                  else if (ele.identifier == 'sub_role'){
                    contact_identifier = 'csr.' + ele.identifier;
                    self.enrich_master_contact_sub_role_field_columns = self.enrich_master_contact_sub_role_field_columns + ',' + contact_identifier
                  }
                  else if (ele.identifier == 'seniority'){
                    contact_identifier = 'cs.' + ele.identifier;
                    self.enrich_master_contact_seniority_field_columns = self.enrich_master_contact_seniority_field_columns + ',' + contact_identifier
                  }
                 
                }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };


              self.columnDefs.push(ele);
            });


          localStorage.setItem("enrich_master_contact_core_field_columns", self.enrich_master_contact_core_field_columns);
          localStorage.setItem("enrich_master_contact_job_title_field_columns", self.enrich_master_contact_job_title_field_columns);
          localStorage.setItem("enrich_master_contact_email_field_columns", self.enrich_master_contact_email_field_columns);
          localStorage.setItem("enrich_master_contact_ddi_field_columns", self.enrich_master_contact_ddi_field_columns);
          localStorage.setItem("enrich_master_contact_mobile_field_columns", self.enrich_master_contact_mobile_field_columns);
          localStorage.setItem("enrich_master_contact_role_field_columns", self.enrich_master_contact_role_field_columns);
          localStorage.setItem("enrich_master_contact_sub_role_field_columns", self.enrich_master_contact_sub_role_field_columns);
          localStorage.setItem("enrich_master_contact_seniority_field_columns", self.enrich_master_contact_seniority_field_columns);
          localStorage.setItem("enrich_master_contact_social_media_field_columns", self.enrich_master_contact_social_media_field_columns);
          


          localStorage.setItem("enrich_master_contact_none_core_field_columns", self.enrich_master_contact_none_core_field_columns);
          localStorage.setItem("enrich_master_contact_none_core_field_ids", self.enrich_master_contact_none_core_field_ids);


      




      


















        })
        .catch(err => {
          console.log("ERR" , err);
        });
    },



  //   getAllAccountSelectedCampaignColumns() {
  //     var self = this;
  //     self.$store
  //       .dispatch(
  //         "campaignsManagement/getAllAccountSelectedCampaignColumns",
  //         self.$route.params.campaignId
  //       )
  //       .then(res => {
  //         if (res.data.status == "success") {
  //             let selected_columns = res.data.data;



  //             selected_columns = selected_columns.filter(function(ele) {
  //               return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' 
  //             });


  //             var index = 1;
  //           selected_columns.forEach(function(ele) {

          
  //             ele.headerName = ele.name;

  //             if (ele.identifier == 'none_core_field') {
  //               ele.field = '_' + ele.id.replaceAll("-", "_");
  //               let ele_with_t = 'acc' + index + '.' + ele.field;
  //               self.enrich_master_account_none_core_field_columns = self.enrich_master_account_none_core_field_columns + ',' + ele.id;
  //               self.enrich_master_account_none_core_field_ids = self.enrich_master_account_none_core_field_ids + ',' + ele_with_t;
  //               index += 1;

  //               }else{
  //                 ele.field = ele.identifier;
  //               }


  //               if (ele.type == "date") {
  //                 ele.filter = "agDateColumnFilter";
  //               } else if (ele.type == "number") {
  //                 ele.filter = "agNumberColumnFilter";
  //               } else {
  //                 ele.filter = "agTextColumnFilter";
  //               }



  //             ele.width = 170;
  //             ele.filterParams = {
  //               buttons: ["apply", "reset"],
  //               maxNumConditions: 4
  //             };
  //           });


  //         self.accountColumnDefs = selected_columns

  //         localStorage.setItem("enrich_master_account_none_core_field_columns", self.enrich_master_account_none_core_field_columns);
  //         localStorage.setItem("enrich_master_account_none_core_field_ids", self.enrich_master_account_none_core_field_ids);




  //           self.accountColumnDefs.push({ pinned: true, checkboxSelection: true, headerName: "#", width: 50 }
  //           );


  //           self.getAllContactSelectedCampaignColumns()
  //         }

        

  //       })
  //       .catch(err => {
  //         console.log(err);
  //       });
  //   },
  //   getAllContactSelectedCampaignColumns() {
  //   var self = this;
  //   self.$store
  //     .dispatch(
  //       "campaignsManagement/getAllContactSelectedCampaignColumns",
  //       self.$route.params.campaignId
  //     )
  //     .then(res => {
  //       if (res.data.status == "success") {
  //           let selected_columns = res.data.data;


  //           selected_columns = selected_columns.filter(function(ele) {
  //             return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' 
  //           });

  //           var index = 1;
  //           selected_columns.forEach(function(ele) {

          
  //             ele.headerName = ele.name;

  //             if (ele.identifier == 'none_core_field') {
  //               ele.field = '_' + ele.id.replaceAll("-", "_");
  //               let ele_with_t = 'con' + index + '.' + ele.field;
  //               self.enrich_master_contact_none_core_field_columns = self.enrich_master_contact_none_core_field_columns + ',' + ele.id;
  //               self.enrich_master_contact_none_core_field_ids = self.enrich_master_contact_none_core_field_ids + ',' + ele_with_t;
  //               index += 1;

  //               }else{
  //                 ele.field = ele.identifier;
  //               }


  //               if (ele.type == "date") {
  //                 ele.filter = "agDateColumnFilter";
  //               } else if (ele.type == "number") {
  //                 ele.filter = "agNumberColumnFilter";
  //               } else {
  //                 ele.filter = "agTextColumnFilter";
  //               }



  //             ele.width = 170;
  //             ele.filterParams = {
  //               buttons: ["apply", "reset"],
  //               maxNumConditions: 4
  //             };
  //           });


  //         self.contactColumnDefs = selected_columns

  //         localStorage.setItem("enrich_master_contact_none_core_field_columns", self.enrich_master_contact_none_core_field_columns);
  //         localStorage.setItem("enrich_master_contact_none_core_field_ids", self.enrich_master_contact_none_core_field_ids);


      
  //       }

      

  //     })
  //     .catch(err => {
  //       console.log(err);
  //     });
  // },
    getDataSource() {
      var self = this;
      window.live_campaign_status = true;
      window.completed_campaign_status = true;
      window.member_campaign_status = true;
      window.paused_campaign_status = true;

    

      this.dataSource = {
        getRows(params) {
          if (params.request.filterModel[0] !== undefined) {
            let filtered_campaign_status =
              params.request.filterModel[0].campaign_status;
            if (filtered_campaign_status.text_format) {
              window.live_campaign_status = true;
            } else {
              window.live_campaign_status = false;
            }

            if (filtered_campaign_status.check_circle_outline) {
              window.completed_campaign_status = true;
            } else {
              window.completed_campaign_status = false;
            }

            if (filtered_campaign_status.pause_circle_outline) {
              window.paused_campaign_status = true;
            } else {
              window.paused_campaign_status = false;
            }

            if (filtered_campaign_status.perm_identity) {
              window.member_campaign_status = true;
            } else {
              window.member_campaign_status = false;
            }
          }
          params.request.enrich_master_account_website_field_columns = localStorage.getItem("enrich_master_account_website_field_columns");
          params.request.enrich_master_account_linkedin_field_columns = localStorage.getItem("enrich_master_account_linkedin_field_columns");

          params.request.enrich_master_account_phone_field_columns = localStorage.getItem("enrich_master_account_phone_field_columns");
          params.request.enrich_master_account_switchboard_field_columns = localStorage.getItem("enrich_master_account_switchboard_field_columns");


          

          params.request.enrich_master_account_core_field_columns = localStorage.getItem("enrich_master_account_core_field_columns");
          params.request.enrich_master_contact_core_field_columns = localStorage.getItem("enrich_master_contact_core_field_columns");
          params.request.enrich_master_contact_job_title_field_columns = localStorage.getItem("enrich_master_contact_job_title_field_columns");
          params.request.enrich_master_contact_email_field_columns = localStorage.getItem("enrich_master_contact_email_field_columns");
          params.request.enrich_master_contact_mobile_field_columns = localStorage.getItem("enrich_master_contact_mobile_field_columns");
          params.request.enrich_master_contact_ddi_field_columns = localStorage.getItem("enrich_master_contact_ddi_field_columns");
          params.request.enrich_master_contact_role_field_columns = localStorage.getItem("enrich_master_contact_role_field_columns");
          params.request.enrich_master_contact_sub_role_field_columns = localStorage.getItem("enrich_master_contact_sub_role_field_columns");
          params.request.enrich_master_contact_seniority_field_columns = localStorage.getItem("enrich_master_contact_seniority_field_columns");
          params.request.enrich_master_contact_social_media_field_columns = localStorage.getItem("enrich_master_contact_social_media_field_columns");



          params.request.enrich_master_account_none_core_field_columns = localStorage.getItem("enrich_master_account_none_core_field_columns");
          params.request.enrich_master_account_none_core_field_ids = localStorage.getItem("enrich_master_account_none_core_field_ids");

          params.request.enrich_none_core_number_type_ids = localStorage.getItem("enrich_none_core_number_type_ids");

          
          params.request.enrich_master_contact_none_core_field_columns = localStorage.getItem("enrich_master_contact_none_core_field_columns");
          params.request.enrich_master_contact_none_core_field_ids = localStorage.getItem("enrich_master_contact_none_core_field_ids");
          params.request.campaignId = self.$route.params.campaignId;

          // console.log(JSON.stringify(params.request, null, 1));
          self.$store
            .dispatch(
              "accountsManagement/fetchDBAccountsContacts",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;

              if (response_data.length != 0) {
                self.$refs.AddNewAccountsWithAdvancedCriteria.gridApi.hideOverlay();

                params.success({ rowData: response.rows , rowCount: response.lastRow })



                self.$refs.AddNewAccountsWithAdvancedCriteria.gridApi.getRenderedNodes().forEach(node => {


self.selected_contact_ids.forEach(function(ele) {
  if (node != undefined) {

    if (self.selected_contact_ids.includes(node.data.contact_id)) {
  node.setSelected(true);
}
    
  }

return;
});

});



              } else {
                self.$refs.AddNewAccountsWithAdvancedCriteria.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    showCampaignStatusPopup(value) {
      if (value.campaigns.length != 0) {
        this.selected_contact_details = value;
        const key = "uuid";
        this.selected_contact_details_campaigns = [
          ...new Map(
            this.selected_contact_details.campaigns.map(item => [
              item[key],
              item
            ])
          ).values()
        ];
        let self = this;
        self.selected_contact_details_campaigns.map(function(ele) {
          self.campaign_statuses.push(ele.campaign_status);
        });
        self.showCampaignDetailsPopUp = true;
      }
    },
    goBack: function() {
      this.$router.go(-1);
    },
    finish: function() {
      this.$router
        .push("/accounts/matched/" + this.$route.params.campaignId + '/' + btoa(this.campaignDescription.campaign_name))
        .catch(() => {});
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaignWithClients", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
          window.campaignDescriptionWithClients = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    }
  },

  beforeMount() {
    this.getDataSource();
  },
  mounted() {
    this.getCampaignDescription();
    this.getSelectedCampaignFieldForEnrich()


  },
  destroyed() {
    // localStorage.removeItem('enrich_advanced_data_reloaded')
    // localStorage.removeItem('enrich_master_account_website_field_columns')
    // localStorage.removeItem('enrich_master_account_linkedin_field_columns')
    // localStorage.removeItem('enrich_master_account_sic_code_field_columns')
    // localStorage.removeItem('enrich_master_account_phone_field_columns')
    // localStorage.removeItem('enrich_master_account_switchboard_field_columns')
    // localStorage.removeItem('enrich_master_contact_job_title_field_columns')
    // localStorage.removeItem('enrich_master_contact_email_field_columns')
    // localStorage.removeItem('enrich_master_contact_mobile_field_columns')
    // localStorage.removeItem('enrich_master_contact_ddi_field_columns')
    // localStorage.removeItem('enrich_master_contact_role_field_columns')
    // localStorage.removeItem('enrich_master_contact_sub_role_field_columns')
    // localStorage.removeItem('enrich_master_contact_seniority_field_columns')
    // localStorage.removeItem('enrich_master_contact_social_media_field_columns')
    // localStorage.removeItem('enrich_master_account_core_field_columns')
    // localStorage.removeItem('enrich_master_contact_core_field_columns')
    // localStorage.removeItem('enrich_master_account_none_core_field_columns')
    // localStorage.removeItem('enrich_master_account_none_core_field_ids')
    // localStorage.removeItem('enrich_none_core_number_type_ids')

    
    // localStorage.removeItem('enrich_master_contact_none_core_field_columns')
    // localStorage.removeItem('enrich_master_contact_none_core_field_ids')




  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;


  }
};
</script>

<style lang="scss">


.example-header {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 16px;
  margin-bottom: 15px;
}

.example-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#page-size {
  padding: 5px 10px;
}
</style>
